import React from 'react';
import { Modal, Box } from '@mui/material';
import { IMAGE_URL } from '../constants/Constants';
import GrandPrixScores from '../dataDisplay/GrandPrixScores';

const ScoresModal = ({ open, handleClose, scoreHistory }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box sx={{
                padding: '16px',
                backgroundColor: '#f5f5f5',
                borderRadius: '8px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                width: '90%',  // Adjust modal width
                borderColor: 'black',
                border: 3,
                maxHeight: '90vh',
                overflow: 'hidden', // Prevent scrolling on the modal itself
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden'
                }}>
                    <img
                        loading="lazy"
                        src={`${IMAGE_URL}headers/Standings.png`}
                        style={{ width: '90%', maxWidth: '350px' }}
                        alt="Standings"
                    />
                </Box>

                <Box sx={{
                    overflowY: 'auto',
                    maxHeight: '65vh',
                    paddingRight: '2px',
                    overflow: 'hidden',
                    
                }}>
                    <GrandPrixScores scoreHistory={scoreHistory[scoreHistory.length - 1]} />
                </Box>
            </Box>
        </Modal>
    );
};

export default ScoresModal;
